<template>
    <Layout :header="{ text: '視訊作業', backBtn: { visible: true }, closeBtn: { visible: false, to: {} }, }">

        <div class="pt-12 pb-16 text-center">
            <img :src="require(`@/assets/images/cec/videoImg.jpg`)" class="mx-auto w-[168px] h-[168px]" v-if="true">
            <div class="mx-auto w-[168px] h-[168px] bg-[#D9D9D9] text-[#CCC]" v-else>
                <div class="inline-block">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                        style="width: 60px;height: 168px;">
                        <title>image</title>
                        <path
                            d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z" />
                    </svg>
                </div>
            </div>
        </div>

        <div class="pb-4">
            <h2 class="font-bold text-2xl">
                視訊作業注意事項
            </h2>
            <ul class="list-disc pt-2 pl-6">
                <li>在光線充足的位置，並勿遮擋臉部，臉部需佔畫面的一半。</li>
                <li>準備本人之身分證，於視訊時出示進行身份核對。</li>
                <li>過程中將會全程錄影及錄音，並加密保存。</li>
                <li>麥克風請維持正常音量，周遭環境請保持安靜。</li>
            </ul>
        </div>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                @click="goNextPage">下一步
            </button>
        </template>
        <Loading :is-loading="isLoading" />
    </Layout>
</template>

<script setup>
import routeName from '@/router/constant.js';
import '@/assets/cloudCounter/css/style.css';
import Layout from '@/components/cloudCounter/Layout.vue';
import { useRouter } from 'vue-router';
import { postInfo } from '@/apis/CloudECounterReserve';
import { onMounted, ref } from 'vue';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import Loading from '@/components/Loading.vue';

const router = useRouter();
const isRead = ref(false);
const isLoading = ref(true);

const checkCameraCapability = async () => {
    if (!window.isSecureContext) return false;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) return false;

    let stream;
    try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoInput = devices.some(device => device.kind === 'videoinput');
        if (!hasVideoInput) return false;

        stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
        return true;
    } catch (error) {
        return false;
    } finally {
        // Always release provisional camera stream to avoid blocking later TakingPhoto usage.
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
    }
};

const init = async () => {
    const hasCameraCapability = await checkCameraCapability();

    if (hasCameraCapability) {
        postInfo().then(res => {
            isRead.value = res.data.agreeTermsVoList.every(item => item.read === true);
        }).catch(ex => {
            openPopupCatchMessage(ex);
        }).finally(() => {
            isLoading.value = false;
        });
    } else {
        isLoading.value = false;
        openPopup('視訊作業需進行身分證件拍照上傳，您目前使用的裝置無拍照功能，請確認，謝謝 ');
    }
};
const goNextPage = () => {
    if (isRead.value) {
        router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_RECORD });
    } else {
        router.push({ name: routeName.CLOUD_E_COUNTER_RESERVE_NOTICE });
    }
};
onMounted(() => {
    init();
});
</script>

<style scoped lang="scss"></style>
